import { VAS_ICON_MAP, VAS_MAP } from './constants';
import { Vas } from '../../../components/OfferCard/Vas';
import { useOfferContext } from '../../../context';
import { EVas } from '../../../types/offers';

// Типы продвижения по приоритетам: Топ + Ставка аукциона --> Топ --> Премиум --> Стандарт
export const OfferVasContainer = () => {
  const { offer } = useOfferContext();

  const { isStandard, isAuction, isTop3, isPremium } = offer;

  if (isAuction && isTop3) {
    return (
      <Vas
        items={[VAS_MAP[EVas.Top], VAS_MAP[EVas.Auction]]}
        name={VAS_MAP[EVas.Top].name}
        icon={VAS_ICON_MAP[EVas.Auction]}
      />
    );
  }

  if (isTop3) {
    return <Vas items={[VAS_MAP[EVas.Top]]} name={VAS_MAP[EVas.Top].name} icon={VAS_ICON_MAP[EVas.Top]} />;
  }

  if (isPremium) {
    return <Vas items={[VAS_MAP[EVas.Premium]]} name={VAS_MAP[EVas.Premium].name} icon={VAS_ICON_MAP[EVas.Premium]} />;
  }

  if (isStandard) {
    return (
      <Vas items={[VAS_MAP[EVas.Standard]]} name={VAS_MAP[EVas.Standard].name} icon={VAS_ICON_MAP[EVas.Standard]} />
    );
  }

  return null;
};
